(function () {
  function buildMarqueeTrack(track) {
    var originalHTML =
      track.getAttribute("data-marquee-original") || track.innerHTML.trim();

    if (!originalHTML) return;

    track.setAttribute("data-marquee-original", originalHTML);
    track.classList.remove("po-marquee-animate");
    track.innerHTML = originalHTML;

    var copies = 1;
    var minWidth = window.innerWidth * 2;

    while (track.scrollWidth < minWidth || copies < 2) {
      track.innerHTML += originalHTML;
      copies += 1;
    }

    track.style.setProperty("--po-marquee-copies", String(copies));
    track.dataset.marqueeReady = "true";

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      track.classList.add("po-marquee-animate");
    }
  }

  function initPartnerOfferMarquee(root) {
    var tracks = (root || document).querySelectorAll("[data-partner-offer-marquee]");
    tracks.forEach(buildMarqueeTrack);
  }

  function init(scope) {
    initPartnerOfferMarquee(scope || document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll("[data-partner-offer-marquee]").forEach(function (track) {
        track.dataset.marqueeReady = "false";
      });
      initPartnerOfferMarquee(document);
    }, 200);
  });
})();
